import { Email, Pill } from "./UserPillStyles";
import Icon from "../Icon";
import React from "react";
import { useUser } from "../../../utils/hooks/commonly-stored/users";
import { UserSummary } from "../../../reducers/models/users";

export default function UserPill({ user }: { user: UserSummary }) {
  return (
    <Pill>
      <Icon src={"/icons/person.svg"} alt={"Owner"} iconDimension={16} />
      <Email>{user.email}</Email>
    </Pill>
  );
}

export function UserIdPill({ userId }: { userId: string | null }) {
  const { user } = useUser(userId);
  if (user !== null) {
    return <UserPill user={user} />;
  }
}
